import React from 'react';
import PropTypes from 'prop-types';

const List = ({ data, listType }) => {
    if (listType === 'ol') {
        return (
            <ol id="list-ol">
                {
                    data.map((elem) => (
                        Array.isArray(elem)
                            ? <List data={ elem } key={ elem } listType={ listType }/>
                            : <li key={ elem } dangerouslySetInnerHTML={ { __html: elem } }/>
                    ))
                }
            </ol>
        );
    }

    return (
        <ul id="list-ul">
            {
                data.map((elem) => (
                    Array.isArray(elem)
                        ? <List data={ elem } key={ elem } listType={ listType }/>
                        : <li key={ elem } dangerouslySetInnerHTML={ { __html: elem } }/>
                ))
            }
        </ul>
    );
};

List.defaultProps = {
    listType: 'ul'
};

List.propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    listType: PropTypes.string
};

export default List;



// WEBPACK FOOTER //
// ./src/components/helpers/List.jsx